import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {useState} from 'react';
import {ActionButton} from '../buttons';

type ConfirmProps = {
  open: boolean;
  title: string;
  description?: string;
  singleOption?: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
};

export const Confirm = ({
  open,
  title,
  description,
  singleOption,
  onConfirm,
  onClose,
}: ConfirmProps) => {
  const [loading, setLoading] = useState(false);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle
        id="alert-dialog-title"
        className="small-title"
        sx={{
          fontSize: 16,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        {description && (
          <DialogContentText id="alert-dialog-description">
            {description}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        {!singleOption && (
          <ActionButton onClick={onClose} variant="outline">
            Cancel
          </ActionButton>
        )}
        <ActionButton
          onClick={async () => {
            setLoading(true);
            try {
              await onConfirm();
              onClose();
            } finally {
              setLoading(false);
            }
          }}
          autoFocus
          variant="primary"
          loading={loading}
        >
          {singleOption ? 'OK' : 'Confirm'}
        </ActionButton>
      </DialogActions>
    </Dialog>
  );
};
